import Script from 'next/script';
import type { TenantId } from '../../../tenants/types/tenant';
import { isTenantExpCA, isTenantExpUS } from '@tenants';

interface ExpScriptProps {
  id: string;
  strategy: 'beforeInteractive' | 'afterInteractive';
  functionalCookiesEnabled: boolean;
  tenantId: TenantId;
  src?: string;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
}

export const ExpScript = ({ id, strategy, functionalCookiesEnabled, tenantId, src, dangerouslySetInnerHTML }: ExpScriptProps) => {
  const isExpTenant = isTenantExpCA(tenantId) || isTenantExpUS(tenantId);

  if (!functionalCookiesEnabled || !isExpTenant) {
    return null;
  }

  return <Script id={id} strategy={strategy} src={src} dangerouslySetInnerHTML={dangerouslySetInnerHTML} />;
};
